import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import IconListItem from './IconListItem.js';

const IconList = ({ title , items =[] , theme ='bar' , className  })=>/*#__PURE__*/ React.createElement("article", {
        className: classnames('icon-list', className, {
            'icon-list--tiles': theme === 'tiles'
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        className: "icon-list__title"
    }, title), /*#__PURE__*/ React.createElement("ul", {
        className: "icon-list__items"
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement(IconListItem, swcHelpers.extends({}, item, {
            key: `${item.icon}-${index}`
        }))
    ))))
;
var IconList$1 = /*#__PURE__*/ React.memo(IconList);

export { IconList, IconList$1 as default };
//# sourceMappingURL=IconList.js.map
